<template>
  <div class="profile-page-view">
    <div class="scroll-wrapper">
       <MyContent />
    </div>
    <MovieNav />
  </div>
</template>

<script>
import MyContent from "../../components/my/MyContent.vue";
import MovieNav from "../../components/footnav/MovieNav.vue";

export default {
  name: 'MovieMy',
  components: { MyContent, MovieNav }
};
</script>

<style lang="scss" scoped>
.profile-page-view {
  background-color: #f8f8f8;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .scroll-wrapper {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 5rem;
  }
}
</style>
